import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e61acbbc")

_pushScopeId("data-v-e61acbbc")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "ctrl-buttons" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "center title-1" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "center title-1" }
const _hoisted_8 = {
  key: 0,
  class: "buttons-container"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("dig-ui-title", { class: "title-2 center" }, " Modifier mon mot de passe ", -1)
const _hoisted_10 = { class: "buttons-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_user_display = _resolveComponent("user-display")
  const _component_user_form = _resolveComponent("user-form")
  const _component_base_card = _resolveComponent("base-card")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_base_card, { class: "main-card" }, {
      default: _withId(() => [
        (!$setup.storeAuth.getters[$setup.StoreGettersAuth.LOGGED_USER])
          ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString($setup.t('noDataAccount')), 1))
          : _createCommentVNode("", true),
        ($setup.storeAuth.getters[$setup.StoreGettersAuth.LOGGED_USER])
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                (!$setup.editing)
                  ? (_openBlock(), _createBlock("dig-ui-edit-button", {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleEditing())),
                      class: "icon-button"
                    }))
                  : _createCommentVNode("", true),
                ($setup.editing)
                  ? (_openBlock(), _createBlock("dig-ui-close-button", {
                      key: 1,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleEditing())),
                      class: "icon-button"
                    }))
                  : _createCommentVNode("", true)
              ]),
              (!$setup.editing)
                ? (_openBlock(), _createBlock("div", _hoisted_4, [
                    _createVNode("dig-ui-title", _hoisted_5, _toDisplayString($setup.t('myAccount')), 1),
                    _createVNode(_component_user_display, {
                      user: $setup.storeAuth.getters[$setup.StoreGettersAuth.LOGGED_USER]
                    }, null, 8, ["user"])
                  ]))
                : _createCommentVNode("", true),
              ($setup.editing)
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    _createVNode("dig-ui-title", _hoisted_7, _toDisplayString($setup.t('editMyAccount')), 1),
                    _createVNode(_component_user_form, {
                      user: $setup.storeAuth.getters[$setup.StoreGettersAuth.LOGGED_USER],
                      loading: $setup.loadingForm,
                      onValidate: _cache[3] || (_cache[3] = ($event: any) => ($setup.updateUser($event))),
                      onCancel: _cache[4] || (_cache[4] = ($event: any) => ($setup.toggleEditing()))
                    }, null, 8, ["user", "loading"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!$setup.editingPassword)
      ? (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode("dig-ui-standard-button", {
            disabled: $setup.loadingPassword,
            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.editingPassword = true))
          }, " Modifier mon mot de passe ", 8, ["disabled"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_base_card, {
      class: "sub-card",
      hidden: !$setup.editingPassword
    }, {
      default: _withId(() => [
        _hoisted_9,
        _createVNode("dig-input-text", {
          value: $setup.password,
          onInput: _cache[6] || (_cache[6] = ($event: any) => ($setup.password = $event.target.value)),
          type: "password",
          id: "password",
          required: ""
        }, " Nouveau mot de passe ", 40, ["value"]),
        _createVNode("dig-input-text", {
          value: $setup.passwordConf,
          onInput: _cache[7] || (_cache[7] = ($event: any) => ($setup.passwordConf = $event.target.value)),
          type: "password",
          id: "password-conf",
          required: ""
        }, " Confirmation mot de passe ", 40, ["value"]),
        _createVNode("div", _hoisted_10, [
          _createVNode("dig-ui-standard-button", {
            class: "cancel",
            disabled: $setup.loadingPassword,
            onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.editingPassword = false))
          }, " Annuler ", 8, ["disabled"]),
          _createVNode("dig-ui-standard-button", {
            disabled: $setup.loadingPassword,
            onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.updatePassword()))
          }, " Modifier mon mot de passe ", 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["hidden"])
  ], 64))
})